export const DATAMINE_HEADERS = [
    {label: "Name", key: "name", style: {minWidth: "160px", width: '20%'}, access: '', columnFilterEnabled: true, type: 'text'},
    {label: "Designation", key: "designation", style: {minWidth: "160px",width: '15%'}, access: '', columnFilterEnabled: true, type: 'text'},
    {label: "Company", key: "company", style: {minWidth: "140px", width: '15%'}, access: '', columnFilterEnabled: true, type: 'text'},
    {label: "Location", key: "location", style: {minWidth: "140px",width: '15%'}, access: '', columnFilterEnabled: true, type: 'text'},
    {label: "Industry", key: "industry", style: {minWidth: "140px",width: '15%'}, access: '', columnFilterEnabled: true, type: 'text'},
    {label: "Last Synced At", key: "last_synced_at", style: {minWidth: "180px", width: '20%'}, access: 'list_last_synced_at', columnFilterEnabled: false, type: 'date'},
    {label: "Last Job Changed At", key: "recent_job_changed_at", style: {minWidth: "220px"}, access: '', columnFilterEnabled: true, type: 'date'},
    {label: "Email", key: "view_email", style: {minWidth: "140px"}, access: 'generate_possible_email', columnFilterEnabled: false, type: 'button'},
]
export const initialDataState = {
    list: [],
    list_info: {title: "",  parent_list_title: ""},
    report: {},
    query: null,
    term_search: null,
    isLoading: {isFetching: true, id: false},
    totalPages: 0,
    totalCount: 0,
    currentPage: 1,
    lnProspectCount: 0,
    downloadDuration: "90",
    popupsList: {},
    appliedFilters: {},
    errors: {},
    dropDownList: {},
    data_params: {},
    datamine_headers: DATAMINE_HEADERS,
    sortings: {}
}
const reducer = (state, action) => {
    switch(action.type){
        case "SET_STATE": {
            return {
                ...state,
                ...action.payload
            }
        }
        case "SET_LOADING": {
            return {
                ...state,
                isLoading: {...state.isLoading, ...action.payload}
            }
        }
        default: return state;
    }
}
export const setState = (reducer) => {
    return (payload) => {
        reducer({type: 'SET_STATE', payload: payload})
    }
}

export default reducer